import moment from "moment";

const CQ9VIPData = {
  // "domain":"https://lobby.h5c.cqgame.lobby/2/",
  game_id: "999",
  maintain: false,
  name: {
    en: "CQ9 VIP Club",
  },
  param: {
    lobby: {
      ko: "",
      en: "",
      cn: "",
      es: "",
      th: "",
      ja: "",
      vn: "",
      "pt-BR": "",
      id: "",
    },
  },
  background: {
    horizontal: {
      cn: `images/horizontal.png`,
      en: `images/horizontal.png`,
      vn: `images/horizontal.png`,
      th: `images/horizontal.png`,
    },
    vertical: {
      cn: `images/vertical.png`,
      en: `images/vertical.png`,
      vn: `images/vertical.png`,
      th: `images/vertical.png`,
    },
  },
  present_time: moment().add(24, "hour").format("YYYY-MM-DD HH:mm:ss"),
  game_site: 0,
  create_at: moment().add(24, "hour").format("YYYY-MM-DD HH:mm:ss"),
  // "type2":0,
  icon: {
    cn: "images/ifsWpWjg.png",
    en: "images/ifsWpWjg.png",
    vn: "images/ifsWpWjg.png",
    th: "images/ifsWpWjg.png",
  },
  // "type":1,
  // "tag":[],
  id: 999,
  feature_status: true,
  team: "RD1SLOT",
};

export default CQ9VIPData;
